import React from 'react';
import AppealDetailSection from '../../../sections/AdminDashboard/Appeals/AppealDetail';

const AppealDetail = () => <AppealDetailSection />;

export default AppealDetail;
